import ITheme from '@orgnc/core/lib/themes/ITheme';
import { ICategoryTemplate } from '@orgnc/core/lib/themes/templates/category';

export const DIRECTORY_TEMPLATE_NAME = 'directory';

interface DirectoryTemplateConfig {
  rootContent?: React.ComponentType<unknown>;
  childContent?: React.ComponentType<unknown>;
  paths: string[];
  component: ICategoryTemplate['component'];
}

export const getDirectoryTemplate = (
  theme: ITheme
): DirectoryTemplateConfig | undefined => {
  const directoryTemplate = theme.pageTypes.category.templates.find(
    (t) => t.name === DIRECTORY_TEMPLATE_NAME
  );

  if (directoryTemplate === undefined) {
    return undefined;
  }

  return {
    component: directoryTemplate.component,
    paths: (directoryTemplate.options?.paths ?? []) as string[],
    rootContent: directoryTemplate.options?.rootContent as
      | React.ComponentType<unknown>
      | undefined,
    childContent: directoryTemplate.options?.childContent as
      | React.ComponentType<unknown>
      | undefined,
  };
};

export const getDirectoryPathSegments = (
  categoryUri: string | undefined,
  directoryPath: string
) => {
  const pathAfterDirectory = categoryUri?.replace(directoryPath, '') ?? '';

  return pathAfterDirectory.split('/').filter(Boolean);
};

export const getDirectoryPath = (
  directoryTemplate: DirectoryTemplateConfig | undefined,
  categoryUri: string | undefined
) => {
  if (!directoryTemplate) {
    return undefined;
  }

  return directoryTemplate.paths.find((path) => categoryUri?.includes(path));
};
